<template>
  <div class="layout-box flex-column-box">
    <!--巨图-->
    <van-image
      v-if="tabbarActive !== showActiveNum"
      width="100%"
      height="150px"
      fit="fill"
      :src="imageFile"
    />
    <!--<div v-if="tabbarActive === showoutPatienteNum" style="display:flex;">-->
    <!--  <img src="../../assets/images/outpatientPayment.png" alt="" class="img" @click="goMoney">-->
    <!--  <img src="../../assets/images/reportQuery.png" alt="" class="img" style="margin-left:-10px" @click="checkreportQuery">-->
    <!--</div>-->
    <!--<div v-if="tabbarActive === 1" style="display:flex;">-->
    <!--  <img src="../../assets/images/depositPayment.png" alt="" class="img" @click="goDeposit">-->
    <!--  <img src="../../assets/images/hospitalRecord.png" alt="" class="img" style="margin-left:-10px" @click="gohospitalRecord">-->
    <!--</div>-->
    <!-- <van-notice-bar
      v-if="tabbarActive !== showActiveNum"
      left-icon="volume-o"
      :scrollable="false"
    >
      <van-swipe
        vertical
        class="notice-swipe"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item @click="toDynamicInfo(1)">依托高水平医疗机构，加速我院药物临床试验机构成长</van-swipe-item>
        <van-swipe-item @click="toDynamicInfo(2)">党史学习教育 | “沉浸式”体验，让党史学习入脑入心</van-swipe-item>
        <van-swipe-item @click="toDynamicInfo(3)">健康惠民-党员先行｜看！这些医务工作者在干什么？</van-swipe-item>
        <van-swipe-item @click="toDynamicInfo(4)">我院医疗志愿者顺利完成姑苏区儿童新冠疫苗接种工作</van-swipe-item>
        <van-swipe-item @click="toDynamicInfo(5)">在苏外国友人突发心理疾病，广济专家团队对症解难题</van-swipe-item>
      </van-swipe>
    </van-notice-bar> -->
    <div class="middle-box">
      <div v-if="tabbarActive !== showActiveNum" class="guanhuai" @click="changeModule">
        <div class="guanhuai_detail">
          <div class="pic">
            <img src="../../assets/images/guanhuai.png" alt="" style="width:100%;height:100%">
          </div>
          <div style="margin-left:5px">
            关怀模式
          </div>
        </div>
      </div>
      <!--宫格菜单-->
      <van-grid v-if="tabbarActive !== showActiveNum" :column-num="3">
        <van-grid-item v-for="(item, index) in menuList[tabbarActive].childList" :key="`frid${index}`" @click="toPage(item.path)">
          <img slot="icon" :src="item.icon" alt="" class="grid-icon iconfont iconfont-blue" style="width:50%;margin-left:25px">
          <!-- <i class="grid-icon iconfont iconfont-blue" slot="icon" :class="item.icon" /> -->
          <span slot="text" class="grid-text">{{ item.title }}</span>
        </van-grid-item>
      </van-grid>
      <!--我的菜单-->
      <div v-if="tabbarActive === showActiveNum" class="bgimg">
        <div class="my-top-box" style="display:flex">
          <div class="imgStyle">
            <img :src="faceImage" alt="" style="width:100%;height:100%">
          </div>
          <div v-if="userInfo" style="margin-top:30px;margin-left:10px">
            <div class="nameStyle">{{ userInfo.patientName || '' }}</div>
            <div class="identifyStyle">身份证：{{ userInfo.patientSfzh || '--' }}</div>
          </div>
          <div v-else class="add-patient" @click="addPatient">添加就诊人</div>
        </div>
      </div>
      <van-cell-group v-if="tabbarActive === showActiveNum">
        <van-cell
          v-for="(item, index) in menuList[tabbarActive].childList"
          :key="`cell${index}`"
          style="border-bottom:1px solid #ececec;padding-top:17px"
          is-link
          :title="item.title"
          @click="toPage(item.path)"
        >
          <img slot="icon" :src="item.icon" alt="" class="cell-left-icon iconfont iconfont-blue" style="width:10%;margin-top:-8px">
          <!-- <i slot="icon" class="cell-left-icon iconfont iconfont-blue" :class="item.icon" /> -->
        </van-cell>
      </van-cell-group>
    </div>

    <!--底部导航-->
    <van-tabbar v-model="tabbarActive">
      <van-tabbar-item v-for="(item, index) in tabbarList" :key="`tabbar${index}`" @click="changeTabbarActive(index)">
        <div class="tabbar-title">{{ item.title }}</div>
        <i slot="icon" class="tabbar-icon iconfont" :class="item.icon" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import imageFile from '../../assets/images/public/yyLogo.png'
import mixin from '../../mixins'
export default {
  name: 'Layout',
  mixins: [mixin],
  data() {
    return {
      faceImage: require('../../assets/images/default.png'),
      openId: '',
      text: '',
      imageFile: imageFile,
      userInfo: null,
      showoutPatienteNum: 0,
      menuList: [
        {
          name: '门诊',
          childList: [
            {
              title: '我的就诊人',
              icon: require('../../assets/images/myPeople.png'),
              // icon: 'icon-jiuzhenren',
              path: '/myPatient'
            },
            // {
            //   title: '预约挂号',
            //   icon: 'icon-yuyueguahao',
            //   path: '/guahaofangshi'
            // },
            // {
            //   title: '我的排队',
            //   icon: 'icon-paiduishu',
            //   path: '/myline'
            // },

            {
              title: '挂号记录',
              icon: require('../../assets/images/guahao.png'),
              // icon: 'icon-guahaojiluchaxun',
              path: '/guahaojilu'
            },
            // {
            //   title: '门诊缴费记录',
            //   icon: 'icon-jiaofeijilu',
            //   path: '/menzhenjiaofeijilu'
            // },
            {
              title: '我的排队',
              icon: require('../../assets/images/myQuery.png'),
              path: '/myline'
              // path: 'myPatient?url=myline'
              // path: '/myline'
            },
            {
              title: '门诊缴费',
              icon: require('../../assets/images/payMoney.png'),
              path: '/menzhenjiaofei'
            },
            {
              title: '门诊缴费记录',
              icon: require('../../assets/images/payMoney.png'),
              path: '/menzhenjiaofeijilu'
              // path: '/menzhenjiaofeijilu'
            },
            // {
            //   title: '防疫预检登记',
            //   icon: 'icon-yiliao-01',
            //   path: '/yujianfenzhen'
            // }
            // {
            //   title: '患者留言',
            //   icon: 'icon-liuya',
            //   path: '/patientLiuyan'
            // }
            {
              title: '孕检心身问卷',
              icon: require('../../assets/images/yunjianshenxin.png'),
              path: '/yunchanxinshen'
            }
          ]
        },
        {
          name: '住院',
          active: 1,
          childList: [
            {
              title: '押金补缴',
              icon: require('../../assets/images/payMoney.png'),
              path: '/yajinbujiao'
            },
            {
              title: '住院报告',
              icon: require('../../assets/images/guahao.png'),
              path: '/zhuyuanbaogaorecord'
            },
            {
              title: '住院人信息',
              icon: require('../../assets/images/hospitalInfo.png'),
              path: '/zhuyuan-record'
            },
            {
              title: '补缴记录',
              icon: require('../../assets/images/addRecharg.png'),
              path: '/yajinbujiaorecord'
            },
            {
              title: '住院清单',
              icon: require('../../assets/images/hospitalList.png'),
              path: '/zhuyuanriqingdan'
            }
            // {
            //   title: '住院清单',
            //   icon: 'icon-zhuyuanqingdan',
            //   path: '/zhuyuanriqingdan'
            // },
          ]
        },
        /* {
          name: '医院信息',
          active: 2,
          childList: [
            {
              title: '医院介绍',
              icon: 'icon-yiyuanjieshao',
              path: '/yiyuanjieshao'
            },
            {
              title: '科室介绍',
              icon: 'icon-keshijieshao',
              path: '/keshijieshao'
            },
            {
              title: '医生介绍',
              icon: 'icon-yishengyishengjieshao',
              path: '/yishengjieshao'
            },
            {
              title: '来院导航',
              icon: 'icon-daohangdizhi',
              path: '/tMap'
            },
            {
              title: '楼群分布',
              icon: 'icon-louceng',
              path: '/loucengfenbu'
            },
            {
              title: '医院动态',
              icon: 'icon-dongtai',
              path: '/dynamic'
            }
          ]
        }, */
        {
          name: '我的',
          active: 3,
          childList: [
            {
              title: '我的就诊人',
              icon: require('../../assets/images/myInfo.png'),
              // icon: 'icon-jiuzhenren',
              path: '/myPatient'
            },
            // {
            //   title: '我的收藏',
            //   icon: 'icon-wodeshoucang'
            // },
            {
              title: '挂号记录',
              icon: require('../../assets/images/guahaoRecord.png'),
              path: '/guahaojilu'
            // },
            // {
            //   title: '门诊缴费记录',
            //   icon: require('../../assets/images/paymentRecord.png'),
            //   path: '/noFunction'
            //   // path: '/menzhenjiaofeijilu'
            // },
            // {
            //   title: '预检分诊记录',
            //   icon: require('../../assets/images/preRecord.png'),
            //   path: '/yujianfenzhenList'
            }
            // {
            //   title: '住院押金补缴记录',
            //   icon: 'icon-zhuyuanyajin'
            // }
          ]
        }
      ],
      tabbarList: [
        {
          title: '门诊',
          icon: 'icon-menzhen-01'
        },
        {
          title: '住院',
          icon: 'icon-zhuyuan'
        },
        /* {
          title: '医院信息',
          icon: 'icon-yiyuanjieshao'
        }, */
        {
          title: '我的',
          icon: 'icon-wode'
        }
      ],
      tabbarActive: 0,
      showActiveNum: 2,
      message: {
        name: '王哈哈',
        number: '320382199905050000'
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.type) {
      this.changeTabbarActive(this.$route.query.type * 1)
    }
    if (localStorage.userInfo) {
      this.userInfo = JSON.parse(localStorage.userInfo)
    }
  },
  mounted() {
    this.tabbarActive = localStorage.getItem('tabbarActive') * 1
  },
  methods: {
    changeModule() {
      this.$router.push({
        path: '/originModule'
      })
    },
    addPatient() {
      this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
    },
    goDeposit() {
      if (this.tabbarActive === 1 && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push({
        path: '/yajinbujiao'
      })
    },
    gohospitalRecord() {
      if (this.tabbarActive === 1 && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push({
        path: '/zhuyuanbaogaorecord'
      })
    },
    checkreportQuery() {
      this.$router.push({
        path: 'myPatient?url=baogaolist'
      })
    },
    goMoney() {
      this.$router.push({
        path: '/menzhenjiaofei'
      })
    },
    toPage(url) {
      if (!url) return
      if (this.tabbarActive === 1 && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push(url)
    },
    changeTabbarActive(index) {
      localStorage.setItem('tabbarActive', index)
    },
    wechatUserInfo() {
      this.wechatUserInfo().then(res => {
        console.log(res)
      })
    },
    getByAppletsId() {
      this.$Apis.getByAppletsId({ appletsId: this.openId }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          if (res.data.patientSfzh) {
            // this.precheckGetListFun(res.data.patientSfzh)
          }
        }
      })
    },
    // precheckGetListFun (sfzh) {
    //   const time = this.$utils.dateFormat('YYYY-mm-dd', new Date())
    //   this.$Apis.precheckGetList({ sfzh, startTime: `${time} 00:00:00`, endTime: `${time} 23:59:59` }).then(res => {
    //     if (res.code === 200 && !res.data.length) {
    //       this.$router.push({ path: '/yujianfenzhenForm' })
    //     }
    //   })
    // },
    toDynamicInfo(id) {
      this.$router.push(`/dynamicInfo?id=${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.guanhuai{
  position: absolute;
  right: 1px;
  top: 65%;
  z-index: 666;
  border-radius: 5px;
  .guanhuai_detail{
    width: 38px;
    height: 120px;
    background: #2b8cff;
    border-radius: .08rem 0 0 .08rem;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    vertical-align: center;
    color: #ffffff;
    letter-spacing: 4px;
    .pic{
      width: 30px;
      margin: 0 0 .06rem .05rem;
      padding-top: 10px;
      img {
        display: block;
        width: .2rem;
        height: auto;
      }
    }
  }
}
.nameStyle{
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}
.identifyStyle{
  font-size: 14px;
  font-weight: 500;
  margin-top:8px;
  color: #ffffff;
}
.imgStyle{
  width: 60px;
  height: 60px;
  margin-top: 24px;
  margin-left: 15px;
}
.add-patient{
  margin-left: 20px;
  margin-top: 25px;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
}
.bgimg {
  width:95%;
  margin:10px;
  height: 110px;
  background: url('../../assets/images/inpatient-bj.png') center center no-repeat;
  background-size: cover;
  border-radius: .1rem;
}

.img{
  width:47%;
  padding:10px
}
.grid-icon {
  font-size: 30px;
}

.grid-text {
  margin-top: 10px;
}

.cell-left-icon {
  font-size: 20px;
  margin-right: 10px;
}

.van-tabbar-item__icon {
  margin-bottom: 0 !important;
  margin-top: 8px;
}

.van-tabbar-item {
  font-size: 14px !important;
}

.van-tabbar {
  height: auto !important;
  padding-top: 10px;
}

.tabbar-title {
  margin: 5px 0 8px;
}

.tabbar-icon {
  font-size: 24px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.iconfont-blue {
  color: #1677ff;
}
/* .van-swipe-item{
    color: #1677ff;
  }
  .van-notice-bar{
    color: #1677ff;
  } */

</style>
